import styled from 'styled-components'
import { titleColor, greyThemeDark1 } from '@edulastic/colors'

const TABLE_BORDER_RADIUS = '6px'

export const ModalContent = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 12px;
  margin-right: -20px;
  overscroll-behavior: contain;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgb(242, 242, 242, 0.8);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(206, 206, 206);
    border-radius: 4px;
    max-height: 20px;

    &:hover {
      background: #adacac;
    }
  }
`

export const SectionContainer = styled.div`
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${titleColor};
  margin-bottom: 12px;
  margin-top: 0;
`

export const Table = styled.table`
  width: 100%;
  border: #cecaca 1px solid;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: ${TABLE_BORDER_RADIUS};
  overflow: hidden;
`

export const TableHeader = styled.thead`
  background-color: #eeeeee;
  border-bottom: 1px solid #e8e8e8;
`

export const TableRow = styled.tr``

export const TableHeaderCell = styled.th`
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: ${titleColor};
  border-right: 1px solid #e8e8e8;

  &:first-child {
    border-top-left-radius: ${TABLE_BORDER_RADIUS};
  }

  &:last-child {
    border-right: none;
    border-top-right-radius: ${TABLE_BORDER_RADIUS};
  }
`

export const TableCell = styled.td`
  padding: 12px 15px;
  font-size: 14px;
  color: ${greyThemeDark1};
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  vertical-align: top;

  &:last-child {
    border-right: none;
  }
`

export const TableBody = styled.tbody`
  tr:last-child {
    td {
      border-bottom: none;
    }

    td:first-child {
      border-bottom-left-radius: ${TABLE_BORDER_RADIUS};
    }

    td:last-child {
      border-bottom-right-radius: ${TABLE_BORDER_RADIUS};
    }
  }
`

export const CodeCell = styled(TableCell)`
  font-family: 'Courier New', Courier, monospace;
  background-color: #f9f9f9;
  display: table-cell;
  vertical-align: middle;
`

export const Code = styled.code`
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  color: #333;
  white-space: pre-wrap;
  word-break: break-all;
`

export const ExpressionCell = styled(TableCell)`
  .input__math {
    display: inline-block;
  }
`

export const StyledChildrenWrapper = styled.span`
  cursor: pointer;
  display: inline-block;
`

export const StyledDivider = styled.div`
  width: auto;
  height: 1px;
  background-color: #ccc;
  margin-top: 25px;
  margin-left: -45px;
  margin-right: -45px;
`

export const StyledModalDescriptionTextContainer = styled.div`
  margin-bottom: 20px;
`

export const StyledModalTableDescriptionContainer = styled.div`
  margin-bottom: 10px;
`

export const StyledBacktickHelpImage = styled.img`
  display: flex;
  margin: 20px auto 50px;
  padding: 15px;
  border: 1px solid #cecece;
`
